import { readCharacterId } from "./buildDiscoverChatbotCardViewModel";
const discoveryCandidateAccessors = {
    getCreatorId: (candidate) => candidate.creator_user_id,
    getItemId: (candidate) => readCharacterId(candidate) || null,
};
export default discoveryCandidateAccessors;
